import React from 'react';
import {observer} from 'mobx-react';
import s from '../../s';
import {currency, Portal} from '../../../util';

declare var __fast_ship: boolean;

export const Header = observer(() => {
    const docSize = `Fits ${s.ps.docWidth}"w x ${s.ps.docHeight}"h ${s.prod.DocType}`;

    return (
        <div
            id="prod-header"
            className="portal3"
        >
            {s.prod && s.si && (
                <div>
                    {s.prod.ProductID !== 70214 && (!s.si.ManualOverride_Desc || s.si.ManualOverride_Desc.length <= 5) && (
                        <h1>
                            {!s.prod.TitleShowInstName ? '' : `${s.si.InstName}`}
                            {s.si.GSName && s.si.GSName !== '' ? ` - ${s.si.GSName}` : ``} - {s.ui.product_title} - {docSize}
                            {s.prod.DegreeType ? ` for ${s.prod.DegreeType}` : ''}
                        </h1>
                    )}
                    {s.prod.ProductID !== 70214 && s.si.ManualOverride_Desc && s.si.ManualOverride_Desc.length > 5 && (
                        <h1>
                            {s.si.ManualOverride_Desc}
                            {s.si.GSName && s.si.GSName !== '' ? ` - ${s.si.GSName}` : ``} - {docSize}
                            {s.prod.DegreeType ? ` for ${s.prod.DegreeType}` : ''}
                        </h1>
                    )}
                    {s.prod.ProductID === 70214 && <h1>Graduation Stole Frame</h1>}
                </div>
            )}
            {s.ui.show_pricing && <span className="msrp-disc">{currency(s.ui.price === s.ui.price_discount ? s.ui.price : s.ui.price_discount)}</span>}

            {__fast_ship && s.isRetail && s.si && s.si.StoreTypeID !== 5 && s.__fast_ship_orig && Portal?.PortalID === 3 && (
                <div className={`fast-ship-container-3`}>
                    <div>
                        <i className="fas fa-cart-shopping-fast"></i>
                    </div>
                    <div>= SHIPS IN 2-3 DAYS</div>
                </div>
            )}
        </div>
    );
});
